import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';

export class RF_SelectAction extends Component {
    static displayName = RF_SelectAction.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            isInventoryAvailableOnTransfer: false,
            createdDocket: 0,
            namecode: "",
            inventoriesInTransfer: [],
            transferCreatedBy: "",
            transferUpdatedBy: "",
            selectedAction: "Pick",
            clientName:""
        }
    }

    componentDidMount() {
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
                this.setState({
                    isInventoryAvailableOnTransfer: rf_transfersettings.isInventoryAvailableOnTransfer,
                    createdDocket: rf_transfersettings.createdDocket,
                    namecode: rf_transfersettings.namecode,
                    clientName: rf_transfersettings.clientName
                });
                if (rf_transfersettings.createdDocket && rf_transfersettings.namecode) {
                    this.loadInventoryContentsInTransfer(rf_transfersettings.createdDocket, rf_transfersettings.namecode);
                    this.loadDocketDetails(rf_transfersettings.createdDocket, rf_transfersettings.namecode);
                }
            }
        }
    }
    async loadInventoryContentsInTransfer(createdDocket, namecode) {

        this.state.loading = true;
        fetch(`api/Transfer/GetInventoryLinesInTransfer?docketNumber=${createdDocket}&namecode=${namecode}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load Inventories in Transfer. " + errorText });
                }
                else {
                    this.setState({ inventoriesInTransfer: data, isInventoryAvailableOnTransfer: (data && data.length > 0) ? true : false, enableCompleteButton: (!data || data.length == 0) ? true : false });

                }

            })
            .catch(error => {
                this.setState({ inventoriesInTransfer: [], alertMessage: error });
            });

    }
    async loadDocketDetails(createdDocket, namecode) {

        if (createdDocket > 0) {
            this.state.loading = true;
            fetch(`api/Transfer/GetDocketDetails?docketNumber=${createdDocket}&namecode=${namecode}`)
                .then(async response => {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const data = isJson ? await response.json() : null;

                    this.state.loading = false;
                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        this.setState({ alertMessage: "Failed to load details of user who created/updated the Transfer " + errorText });
                    }
                    else {

                        if (data.notes) {
                            var staffNames = data.notes.split("/");
                            var createdBy = staffNames[0];
                            var updatedBy = staffNames[1]
                            if (createdBy && createdBy.length > 0) {
                                var createdByName = createdBy.split(":")[1];
                                if (createdByName) {
                                    this.setState({ transferCreatedBy: "Transfer Created By : " + createdByName });
                                }
                            }
                            if (updatedBy && updatedBy.length > 0) {
                                var updatedByName = updatedBy.split(":")[1];
                                if (updatedByName) {
                                    this.setState({ transferUpdatedBy: "Transfer Updated By : " + updatedByName });
                                }
                            }

                        }
                    }
                })
                .catch(error => {
                    this.state.loading = false;
                    this.setState({ alertMessage: "Failed to load details of user who created/updated the Transfer " + error });
                });
        }

    }
    async finaliseDocket() {
        if (this.state.createdDocket <= 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Finalise Docket Failed!! Docket Number cannot be zero" });
            return;
        }
        if (this.state.inventoriesInTransfer.length > 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Finalise Docket Failed!! Please move items in Transfer to a location and then attempt Finalise Docket" });
            return;
        }
        this.setState({ alertMessage: "" });
        this.state.loading = true;
        const finaliseDocketReqest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Namecode: this.state.namecode,
                DocketId: this.state.createdDocket,
                WarehouseId: MyGlobal.warehouse,
                StaffName: MyGlobal.staffName
            })
        };
        fetch('api/Transfer/FinaliseDocket', finaliseDocketReqest)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Finalise Docket Failed!! " + errorText });
                    return;
                }
                else {

                    if (!data.success) {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Finalise Docket Failed!! " + data.responseText });
                        return;
                    }
                    else {

                        MySound.play(MySound.Sound.next);
                        this.goto('../Transfer');
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                MySound.play(MySound.Sound.stop);
                this.setState({ alertMessage: error });
            });
    }

    setRF_TransferGlobalVariables() {
        MyGlobal.rf_transfer = JSON.stringify({
            createdDocket: this.state.createdDocket,
            namecode: this.state.namecode,
            inventoriesInTransfer: this.state.inventoriesInTransfer,
            isInventoryAvailableOnTransfer: this.state.isInventoryAvailableOnTransfer,
            transferCreatedBy: this.state.transferCreatedBy,
            transferUpdatedBy: this.state.transferUpdatedBy,
            selectedAction: this.state.selectedAction,
            clientName: this.state.clientName
        });
    }
    viewStockOnHand(selectedProductCode) {
        this.state.selectedProductCode = selectedProductCode;
        this.goto('RF_StockOnHand');
    }

    goto(page, selectedAction) {
        if (selectedAction) {
           this.state.selectedAction = selectedAction;
        }
        this.setRF_TransferGlobalVariables();
        this.history.push({
            pathname: page,
            state: this.state
        });
    }
    renderInventoryContentsInTransfer() {

        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Barcode</th>
                        <th>Description</th>
                        <th>PackingDate</th>
                        <th>ExpiryDate</th>
                        <th>Units</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.inventoriesInTransfer.map((row, index) =>
                        <tr key={index}>
                            <td>{row.productCode}</td>
                            <td>{row.barcode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.grades?.packingDate ? new Date(row.grades?.packingDate).toLocaleDateString() : ''}</td>
                            <td>{row.grades?.expiryDate ? new Date(row.grades?.expiryDate).toLocaleDateString() : ''}</td>
                            <td>{row.units}</td>
                            <td> <button type="button" className="btn btn-success col-12" onClick={() => { this.viewStockOnHand(row.productCode); }}  >SOH</button></td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let inventoryContentsInTransfer = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderInventoryContentsInTransfer();
        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../Transfer'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><h4>Select Action</h4></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><b> {this.state.transferCreatedBy} </b></Col>
                        <Col><b> {this.state.transferUpdatedBy} </b></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={6}>
                            <label>Client : {this.state.clientName}</label>
                        </Col>
                        <Col xs={6}>
                            <label>Docket : {this.state.createdDocket}</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}> Picking inventory allows you to remove inventory from a location </Col>
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.goto('RF_AdhocTransfer', 'Pick'); }} >Pick</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}> Putting inventory allows you to place inventory into a location </Col>
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.goto('RF_AdhocTransfer', 'Put'); }} disabled={!this.state.isInventoryAvailableOnTransfer } >Put</button>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.finaliseDocket(); }} disabled={!this.state.enableCompleteButton} >Complete</button>
                        </Col>
                    </Row>
                    <br></br>
                    <Row className="mb-3">
                        <Col xs={12}> <h5> Inventories In Transfer </h5></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContentsInTransfer}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}